//@ts-ignore
import CharusatLogo from '../images/organizations/charusat.jpg';
//@ts-ignore
import BapsSvmLogo from '../images/organizations/baps_svm.png';

export const EducationData = [
  {
    organizationProfile: {
      // title: 'Charotar University of Science and Technology',
      title: 'CHARUSAT',
      location: 'Anand, India',
      imageUrl: CharusatLogo
    },
    relevantBackground: [
      {
        title: 'Master of Computer Applications',
        location: 'Anand, India',
        startingFrom: 'July, 2020',
        endedAt: 'May, 2022'
      },
      {
        title: 'Bachelor of Computer Applications',
        location: 'Anand, India',
        startingFrom: 'July, 2017',
        endedAt: 'April, 2020'
      }
    ]
  },
  {
    organizationProfile: {
      title: 'BAPS Swaminarayn Vidhya Mandir',
      location: 'Anand, India',
      imageUrl: BapsSvmLogo
    },
    relevantBackground: [
      {
        title: 'Higher Secondary Education - Commerce',
        location: 'Anand, India',
        startingFrom: 'June, 2015',
        endedAt: 'March, 2017'
      }
    ]
  }
];
